import React from 'react'

import Select from 'react-select'
import axios from 'axios'
import {getToken} from '../../../storage'
import {API_BASE_URL} from '../../../constants'
import {AddSupplierModal} from '../../modal/modal'


class SupplierNameExtended extends React.Component {

  render() {

    const option = this.props.option


    return  <div>
            <div>
                {option.name}
            </div>
            <div>
                {option.gstin}
            </div>
            <div>
                <strong>{option.address} {option.city}</strong>
            </div>
    </div>
  }
}

class SupplierWithCity extends React.Component {

  render() {
    const option = this.props.option
    return <div>{option.name} {option.city}</div>
  }
}


export default class SupplierElement extends React.Component {

  constructor(props){
    super(props)
    this.handleChange=this.handleChange.bind(this)
    this.createSupplierPromt = this.createSupplierPromt.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.renderValue = this.renderValue.bind(this)
    this.state={showSupplierCreate:false}
  }

  createSupplierPromt(input){
    return "Create new supplier ?"
  }

  handleChange(supplier){
    if(supplier !== null && typeof supplier.className !== "undefined" ) {
      // Do not add supplier for random inputs
        this.setState({showSupplierCreate:true})
    }
    else {
      if (typeof this.props.onAddCallback !== "undefined") {
        this.props.onAddCallback(supplier)
      }
      // this.props.dispatch(addPretnSupplier(supplier))
    }
  }

  getSuppliers (input) {


    if (!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/list_suppliers/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }

        }
      }).then((response)=> {

            return {options: response.data.suppliers}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}

renderOption(option) {
  return <SupplierNameExtended option={option} />
}

renderValue(option) {
  return <SupplierWithCity option ={option} />
}


  render() {


    let inputValue
    if(typeof this.props.pretn !== "undefined") {
      inputValue = this.props.pretn.supplier
    }

    let supplierModal
    if(this.state.showSupplierCreate) {
      supplierModal = <AddSupplierModal onAddCallback={this.props.onAddCallback} />
    }


    return <div>
          {supplierModal}
      <Select.AsyncCreatable name="name" placeHolder="select supplier"
        optionRenderer={this.renderOption} valueRenderer={this.renderValue}
     value={inputValue}  valueKey="id" labelKey="name" loadOptions={this.getSuppliers} onChange={this.handleChange} promptTextCreator={this.createSupplierPromt} autoFocus />
 </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/debit/rowelements/supplierelement.js